import { type Product } from "@/types/types";
import { type CategoryIDList } from "./categoryIds";

export const productIsInCategory = (
  product: Product,
  categoryIDList: CategoryIDList,
) => {
  return product?.browsePageHierarchy?.some((page) =>
    categoryIDList.includes(page.categoryId),
  );
};
